let cachedFormUrl: string | null = null;

export async function get_form_url(): Promise<string> {
  if (cachedFormUrl) return cachedFormUrl;

  cachedFormUrl = 'https://readdy.ai/api/form/d9q7jbnnahb7382ov750';
  return cachedFormUrl;
}